import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <h1 className="display-4 fw-bold mb-4 text-center">Perfect Fit Guaranteed</h1>
          <p className="lead mb-4 text-center">Professional tailoring services with precision and care. Serving is thread that brings us together. Your style, our craftsmanship.</p>
          
          {/* Fixed button container - properly responsive */}
          <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3">
            <Link to="/services" className="btn btn-light btn-lg w-sm-auto">Explore Services</Link>
            <Link to="/gallery" className="btn btn-light btn-lg w-sm-auto">Traverse Gallery</Link>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-5">
        <div className="container">
          <h2 className="text-center mb-5">Our Services</h2>
          <div className="row">
            <div className="col-md-3 mb-4">
              <div className="service-card card h-100">
                <div className="card-body text-center d-flex flex-column">
                  <h5 className="card-title">Chudidhar Stitching</h5>
                  <p className="card-text flex-grow-1">Custom Chudi stitching with perfect measurements</p>
                  <strong className="text-primary">Starting from ₹500</strong>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="service-card card h-100">
                <div className="card-body text-center d-flex flex-column">
                  <h5 className="card-title">Kurtis Stitching</h5>
                  <p className="card-text flex-grow-1">Formal and casual Kurtis tailored to perfection</p>
                  <strong className="text-primary">Starting from ₹300</strong>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="service-card card h-100">
                <div className="card-body text-center d-flex flex-column">
                  <h5 className="card-title">Blouse Stitching</h5>
                  <p className="card-text flex-grow-1">Traditional blouses with modern designs</p>
                  <strong className="text-primary">Starting from ₹300</strong>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="service-card card h-100">
                <div className="card-body text-center d-flex flex-column">
                  <h5 className="card-title">Alterations</h5>
                  <p className="card-text flex-grow-1">Professional clothing alteration services</p>
                  <strong className="text-primary">Starting from ₹150</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <Link to="/services" className="btn btn-primary">View All Services</Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-md-4 text-center mb-4 mb-md-0">
              <div className="mb-3">
                <i className="fas fa-ruler-combined fa-3x text-primary"></i>
              </div>
              <h4>Precise Measurements</h4>
              <p>Detailed body measurements for perfect fitting clothes</p>
            </div>
            <div className="col-md-4 text-center mb-4 mb-md-0">
              <div className="mb-3">
                <i className="fas fa-clock fa-3x text-primary"></i>
              </div>
              <h4>On-Time Delivery</h4>
              <p>We respect your time with guaranteed delivery dates</p>
            </div>
            <div className="col-md-4 text-center">
              <div className="mb-3">
                <i className="fas fa-award fa-3x text-primary"></i>
              </div>
              <h4>Quality Assurance</h4>
              <p>Premium quality fabric and expert craftsmanship</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;